//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ActionBase,
  Illustration,
  Paper,
  Typography,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { ROUTES } from '@router'

export default {
  components: {
    ActionBase,
    Illustration,
    Typography,
    Paper,
  },
  computed: {
    ROUTES: () => ROUTES,
    ...mapGetters({
      buyingGuide: 'landing/buyingGuide',
    }),
    trackingName() {
      return this.$route.name
    },
  },
}
